import { render, staticRenderFns } from "./orderFile.vue?vue&type=template&id=437a38ff&scoped=true"
import script from "./orderFile.vue?vue&type=script&lang=js"
export * from "./orderFile.vue?vue&type=script&lang=js"
import style0 from "./orderFile.vue?vue&type=style&index=0&id=437a38ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437a38ff",
  null
  
)

export default component.exports